import React from 'react'
import {useEffect} from 'react'
import checkinApi from '../../services/api/checkin/checkinApi'
import usePupilData from '../../hooks/usePupilData'
import Questions from '../SurveyView/Questions'
import {AUDIENCE} from '../../utils/constants'
import WbLoader from '../../components/common/WbLoader'
import SubmissionBlocker from '../SurveyView/submissionBlocker'
import WelbeeLogo from '../../components/assets/images/welbee_logo.svg'
import safeSpaceApi from '../../services/api/safespace/safeSpaceApi'
import {useNavigate} from 'react-router-dom'
import paths from '../../routes/paths'

export default function Questionaire() {
  const [loading, setLoading] = React.useState(false)
  const [data, setData] = React.useState(null)
  const [done, setDone] = React.useState(false)
  const [showSafeSpace, setShowSafeSpace] = React.useState(false)
  const [surveyComplete, setSurveyComplete] = React.useState(false)

  const pupil = usePupilData()
  const navigate = useNavigate()
  const handleCompleteSurvey = response => {
    setDone(true)
    if (response[0].numValue1 < 3) {
      setShowSafeSpace(true)
    } else {
      setSurveyComplete(true)
    }
  }

  useEffect(() => {
    setLoading(true)
    safeSpaceApi
      .checkStudentInSafeSpaceAndHasCheckin(
        pupil.schoolId,
        pupil.groupId,
        pupil.studentId
      )
      .then(res => {
        if (res.hasSubmitted) {
          navigate(paths.pupilSurveys)
        } else {
          setDone(false)
          setShowSafeSpace(false)
          setSurveyComplete(false)
          setLoading(true)
          checkinApi
            .GetCheckInForPupil(pupil.schoolId, pupil.groupId, pupil.studentId)
            .then(res => {
              setData(res)
            })
            .finally(() => {
              setLoading(false)
            })
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <div className="questionaire">
      <img
        src={WelbeeLogo}
        alt="Welbee Logo"
        style={{marginTop: '20px', marginLeft: '20px'}}
        width="150"
        height="50"
      />
      {loading && <WbLoader />}
      {!done && (
        <Questions
          questions={data?.questions}
          tab={AUDIENCE.STUDENT}
          participantToken={data?.participantToken}
          handleCompleteSurvey={handleCompleteSurvey}
        />
      )}
      {surveyComplete && <SubmissionBlocker type="end" />}
      {showSafeSpace && <SubmissionBlocker type="safeSpace" pupil={pupil} />}
    </div>
  )
}
